import getMailRootFolderIds from 'mini-mail-folder-store/lib/utils/getMailRootFolderIds';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import PeopleRouteStore, { PeopleRouteType } from 'mini-people-route-store';
import setCurrentPeopleRoute from 'mini-people-route-store/lib/actions/setCurrentPeopleRoute';
import strings from 'owa-strings/owa-mini-people-strings';
import { appAction } from 'mini-app-context';
import { CONTACT_DISTINGUISHED_FOLDER } from 'mini-people-sidepane-view/lib/utils/getPeopleHubFolderType';
import { FoldersSectionTreeData } from 'mini-people-sidepane-view/lib/schema/FoldersSectionTreeData';
import { getAppActionMetaData } from 'mini-people-common/lib/utils/telemetry/getAppActionMetaData';
import { getDefaultFoldersSectionTreeData } from 'mini-people-sidepane-view/lib/utils/getDefaultFoldersSectionTreeData';
import { getStore as getFolderStore } from 'mini-mail-folder-store/lib/store/Store';

export interface FolderValues {
    peopleContacts?: FoldersSectionTreeData;
    mailFavourites?: string[];
    mailFolders?: string[];
    mailFavouritesClose?: boolean;
    mailFoldersClose?: boolean;
}

const configOptions = () => {
    const { location } = PeopleRouteStore;

    const onDefaultFolderClick = appAction((location: PeopleRouteType) => {
        setCurrentPeopleRoute(location);
    }, getAppActionMetaData('SelectFolder', { section: strings.foldersSectionLabel, folderType: CONTACT_DISTINGUISHED_FOLDER }));

    const peopleContacts = getDefaultFoldersSectionTreeData(location, onDefaultFolderClick);

    const store = getFolderStore();

    const mailFavourites = store.orderedFavoritesFolderIds;
    const mailFavouritesClose = getUserConfiguration().UserOptions.IsFavoritesFolderTreeCollapsed;
    const mailFolders = getMailRootFolderIds();
    const mailFoldersClose = getUserConfiguration().UserOptions.IsMailRootFolderTreeCollapsed;

    const folderValuesForConfig: FolderValues = {
        peopleContacts: peopleContacts,
        mailFavourites: mailFavourites,
        mailFavouritesClose: mailFavouritesClose,
        mailFolders: mailFolders,
        mailFoldersClose: mailFoldersClose,
    };

    return folderValuesForConfig;
};

export default configOptions;
